import { colors } from '@dixa/lib-shared-tokens';
import memoizeOne from 'memoize-one';
const themes = [
    {
        name: 'default',
        colors: [
            colors.purple['700'],
            colors.blue['300'],
            colors.red['500'],
            colors.orange['300'],
            colors.purple['500'],
            colors.green['400'],
            colors.neutral['600'],
            colors.neutral['300'],
        ],
    },
    {
        name: 'rating',
        colors: [
            colors.red['700'],
            colors.red['400'],
            colors.orange['300'],
            colors.green['500'],
            colors.green['600'],
        ],
    },
];
const defaultTheme = themes[0];
/**
 * Returns whether an instrument color is a HEX color.
 *
 * @param color The instrument color.
 */
const isHex = (color) => {
    return color.startsWith('#');
};
/**
 * Returns the HEX value of the given instrument color.
 *
 * @param color The instrument color.
 */
export const resolveInstrumentColor = memoizeOne((color) => {
    var _a, _b, _c;
    if (isHex(color))
        return color;
    const [themeName, colorIndex] = color.split('-');
    const theme = (_a = themes.find((theme) => theme.name === themeName)) !== null && _a !== void 0 ? _a : defaultTheme;
    return (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b[Number(colorIndex) - 1]) !== null && _c !== void 0 ? _c : color;
});
/**
 * Returns the color of the chart element.
 *
 * If `color` is a HEX value, it is returned as-is, otherwise if it's a theme
 * color key, it will look up its value in any of the supported themes and
 * return it.
 *
 * If `color` is not provided or not found, it returns the color matching the
 * index of the element in the chart and repeating them when all colors have
 * been used, from the specified or default theme.
 */
export const getChartElementColor = memoizeOne((index, themeName = 'default', colorName) => {
    var _a;
    if (colorName) {
        return resolveInstrumentColor(colorName);
    }
    const theme = (_a = themes.find(({ name }) => name === themeName)) !== null && _a !== void 0 ? _a : defaultTheme;
    return theme.colors[index % theme.colors.length];
});
/** Configuration options used to customize react-grid-layout. */
export const rglConfig = {
    margin: [12, 12],
    containerPadding: [0, 0],
    cols: 24,
    rowHeight: 40,
};
/** Various assets associated to the different instrument types. */
export const instrumentAssets = {
    metric: { icon: 'list-ol', title: 'Metrics' },
    chart: { icon: 'chart-bar', title: 'Chart' },
    table: { icon: 'th', title: 'Table' },
    presence: { icon: 'working', title: 'Presence' },
    ai_insight: { icon: 'ai', title: 'AI insight' },
};
